import langFromUrl from 'lib/util/langFromUrl';

export default function seriesYearTitleSwap(seriesYear, displayName) {
  if (langFromUrl() === 'es') {
    return `${displayName} ${seriesYear}`;
  }
  return `${seriesYear} ${displayName}`;
}
